import { AxiosError } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export interface ApiErrorPayload {
  detail?: string;
  [field: string]: string | undefined;
}

export type ApiError = AxiosError;

type CreateAsyncThunkType = Parameters<typeof createAsyncThunk>[1];
export type GetThunkAPI = Parameters<CreateAsyncThunkType>[1] & {
  rejectWithValue: unknown;
};

export const normalizeApiError = (
  error: unknown,
): ApiErrorPayload | undefined => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    if (data?.detail) {
      return {
        detail: data.detail,
      };
    }

    return;
  }

  if (
    typeof error === "object" &&
    error !== null &&
    "detail" in error &&
    typeof (error as any).detail === "string"
  ) {
    return {
      detail: (error as any).detail,
    };
  }
};

export interface ApiErrorResponse {
  success: boolean;
  message: string;
  errors?: Record<string, string[]> | null;
}

export const handleErrors = (error: ApiError, thunkAPI: GetThunkAPI) => {
  const errorData = error.response?.data as ApiErrorResponse | undefined;

  if (error.status !== 500 && errorData && typeof errorData === "object") {
    return thunkAPI.rejectWithValue(errorData);
  }

  if (error.status === 500) {
    const messages = [
      "Oops! An unexpected error occurred. Please try again soon.",
      "We are experiencing technical issues. Please refresh the page or try again later.",
      "The server encountered an error. We are working to fix it.",
      "Unable to process your request at the moment. Please try again later.",
    ];
    return thunkAPI.rejectWithValue({
      success: false,
      message:
        errorData?.message ||
        messages[Math.floor(Math.random() * messages.length)],
    });
  }

  if (error.status === 400) {
    return thunkAPI.rejectWithValue({
      success: false,
      message: "Invalid request. Please check your input and try again.",
    });
  }

  return thunkAPI.rejectWithValue({
    success: false,
    message: "An error occurred. Please try again.",
  });
};
